<template>
  <div id="grids">
    <h2 class="sg mt-0">Breakpoints list</h2>
    <p>In this table you can visualize all the variations of the layout system values according to the different breakpoints.</p>
    <table class="table table-bordered">
      <thead class="thead-dark">
        <tr>
          <th>Breakpoint</th>
          <th>Device Size</th>
          <th>Container Width</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-title="Breakpoint">&lt; 576px</td>
          <td data-title="Device Size">XS - Extra small devices (Portrait phones)</td>
          <td data-title="Container Width">Auto</td>
        </tr>
        <tr>
          <td data-title="Breakpoint">≥ 576px</td>
          <td data-title="Device Size">SM - Small devices (Landscape phones)</td>
          <td data-title="Container Width">540px</td>
        </tr>
        <tr>
          <td data-title="Breakpoint">≥ 768px</td>
          <td data-title="Device Size">MD - Medium devices (Tablets)</td>
          <td data-title="Container Width">720px</td>
        </tr>
        <tr>
          <td data-title="Breakpoint">≥ 992px</td>
          <td data-title="Device Size">LG - Large devices (Desktops)</td>
          <td data-title="Container Width">960px</td>
        </tr>
        <tr>
          <td data-title="Breakpoint">≥ 1200px</td>
          <td data-title="Device Size">XL - Extra large devices (Large desktops)</td>
          <td data-title="Container Width">1140px</td>
        </tr>
        <tr>
          <td data-title="Breakpoint">≥ 1600px</td>
          <td data-title="Device Size">XXL - Extra extra large devices (Extra large desktops)</td>
          <td data-title="Container Width">1560px</td>
        </tr>
      </tbody>
    </table>
    <p>Developers please check out <a href="/utilities/grid">Utilities Grid</a> for more information on how to code responsive design.</p>

    <hr class="sg-hr">
    <h2>Grids templates in all viewports:</h2>
    <div style="overflow-x: auto;">
      <img src="@/assets/gel/site-images/grids-sm.png">
    </div>
    <p>
      Also, check out
      <a href="/templates/adaptive">Adaptive and Fluid</a> templates built on top of grid systems.
    </p>

        <hr class="sg-hr">
    <h2>Responsive testing list</h2>
    <p>Designers and developers need to test their work against below list. Simply setup those viewports under Toggle Device Toolbar in Chrome DevTools.</p>
    <table class="table table-bordered">
      <thead class="thead-dark">
        <tr>
          <th>Order</th>
          <th>Device Size</th>
          <th>Resolutions</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-title="Order">1</td>
          <td data-title="Device Size">XXL</td>
          <td data-title="Resolutions">1920x1080</td>
        </tr>
        <tr>
          <td data-title="Order">2</td>
          <td data-title="Device Size">XL</td>
          <td data-title="Resolutions">1280x1024</td>
        </tr>
        <tr>
          <td data-title="Order">3</td>
          <td data-title="Device Size">LG</td>
          <td data-title="Resolutions">1050x888</td>
        </tr>
        <tr>
          <td data-title="Order">4</td>
          <td data-title="Device Size">XL</td>
          <td data-title="Resolutions">1536x864</td>
        </tr>
        <tr>
          <td data-title="Order">5</td>
          <td data-title="Device Size">LG</td>
          <td data-title="Resolutions">1024x768 (iPad Landscape)</td>
        </tr>
        <tr>
          <td data-title="Order">6</td>
          <td data-title="Device Size">XS</td>
          <td data-title="Resolutions">414x896 (Samsung)</td>
        </tr>
        <tr>
          <td data-title="Order">7</td>
          <td data-title="Device Size">XS</td>
          <td data-title="Resolutions">375x812 (iPhone X)</td>
        </tr>
        <tr>
          <td data-title="Order">8</td>
          <td data-title="Device Size">MD</td>
          <td data-title="Resolutions">768x1024 (iPad Portrait)</td>
        </tr>
      </tbody>
    </table>
    <p>The order of the list is based on the data (2020) we collected in Google Analytics</p>
  </div>
</template>

<script>
let title = "Grids";
let tagline =
  "Consistent use of a grid system provides the foundation for harmoniously and consistently positioning elements onscreen. Designing to the grid helps create an experience that facilitates understanding and brings order to the page";

export default {
  name: "grids",
  beforeCreate: function() {
    this.$emit("update-title", title);
    this.$emit("update-tagline", tagline);
  }
};
</script>
